import {
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  EventRelatedStatusConfig,
  FINISHED_DESCRIPTION,
  WAITING_FOR_EXTRATIME_DESCRIPTION,
  WAITING_FOR_PENALTY_DESCRIPTION,
} from '../../../configuration'

const otherStatusIncidents: RugbyUnionIncidentId[] = [
  RugbyUnionIncidentId.NotStarted,
  RugbyUnionIncidentId.FinishedAwardedWin,
  RugbyUnionIncidentId.Interrupted,
  RugbyUnionIncidentId.Postponed,
  RugbyUnionIncidentId.Abandoned,
  RugbyUnionIncidentId.Cancelled,
  RugbyUnionIncidentId.ToFinish,
]

export const eventRelatedStatusConfig: EventRelatedStatusConfig<
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId
> = {
  [RugbyUnionEventStatusId.NotStarted]: {
    possibleNextStatusIncidents: [
      RugbyUnionIncidentId.FirstHalf,
      RugbyUnionIncidentId.StartDelayed,
    ],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyUnionIncidentId.NotStarted,
    ),
  },
  [RugbyUnionEventStatusId.FirstHalf]: {
    possibleNextStatusIncidents: [RugbyUnionIncidentId.Halftime],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.Halftime]: {
    possibleNextStatusIncidents: [RugbyUnionIncidentId.SecondHalf],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.SecondHalf]: {
    possibleNextStatusIncidents: [
      {
        incidentId: RugbyUnionIncidentId.FinishedRegularTime,
        description: FINISHED_DESCRIPTION,
      },
      {
        incidentId: RugbyUnionIncidentId.WaitingForExtratime,
        description: WAITING_FOR_EXTRATIME_DESCRIPTION,
      },
      {
        incidentId: RugbyUnionIncidentId.WaitingForPenalty,
        description: WAITING_FOR_PENALTY_DESCRIPTION,
      },
    ],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.WaitingForExtratime]: {
    possibleNextStatusIncidents: [RugbyUnionIncidentId.ExtratimeFirstHalf],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.ExtratimeFirstHalf]: {
    possibleNextStatusIncidents: [RugbyUnionIncidentId.ExtratimeHalftime],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.ExtratimeHalftime]: {
    possibleNextStatusIncidents: [RugbyUnionIncidentId.ExtratimeSecondHalf],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.ExtratimeSecondHalf]: {
    possibleNextStatusIncidents: [
      {
        incidentId: RugbyUnionIncidentId.WaitingForPenalty,
        description: WAITING_FOR_PENALTY_DESCRIPTION,
      },
      RugbyUnionIncidentId.FinishedAfterExtratime,
    ],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.WaitingForPenalty]: {
    possibleNextStatusIncidents: [RugbyUnionIncidentId.PenaltiesStarted],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.Penalties]: {
    possibleNextStatusIncidents: [RugbyUnionIncidentId.FinishedAfterPenalties],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.FinishedRegularTime]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.FinishedAfterExtratime]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [RugbyUnionEventStatusId.Interrupted]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyUnionIncidentId.Interrupted,
    ),
  },
  [RugbyUnionEventStatusId.Postponed]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyUnionIncidentId.Postponed,
    ),
  },
  [RugbyUnionEventStatusId.Abandoned]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyUnionIncidentId.Abandoned,
    ),
  },
  [RugbyUnionEventStatusId.Cancelled]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyUnionIncidentId.Cancelled,
    ),
  },
  [RugbyUnionEventStatusId.ToFinish]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyUnionIncidentId.ToFinish,
    ),
  },
}
